export const EDIT_SUCCESS = 'Марка автомобиля обновлена';
export const EDIT_ERROR = 'Не удалось обновить марку автомобиля';
